import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { IProblem, IProblemProps, IProblemStates } from "./interfaces";

export class Problem extends EntityManager<IProblem, IProblemProps, IProblemStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "Problem",
            title: "مشکلات",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 250,
                    rules: [{ required: true, message: 'لطفا نام را وارد نمایید' }]
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }]
                }
            ]
        };
    }
}